import { lazyNamed } from 'src/utils/lazyNamed.ts';

const Accounts = {
  AccountsList: lazyNamed(() => import('./containers/AccountsList/index.tsx'), 'AccountsList'),
  AccountOverview: lazyNamed(() => import('./containers/AccountOverview/index.tsx'), 'AccountOverview'),
};

export default Accounts;
